import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '../../Tooltip/index.js';

const TipsTitle = ({ title }) => {
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        if (textRef.current) {
            const element = textRef.current;
            const isOverflow = element.scrollWidth > element.clientWidth;
            setIsOverflowing(isOverflow);
        }
    }, [title]);

    return (
        isOverflowing ? (
            <Tooltip
                inverse
                overlay={<div>{title}</div>}
                placement="bottomLeft">
                <span ref={textRef}>{title}</span>
            </Tooltip>
        ) : (
            <span ref={textRef}>{title}</span>
        )
    );
};

export default TipsTitle;